import { defineMessages } from 'react-intl-next';

export default defineMessages({
	actionsMenuTriggerLabel: {
		id: 'navigation.global-side-navigation.nav-item.actions.trigger-label',
		defaultMessage: 'More actions',
		description: 'Label for the button that opens the item actions menu',
	},
});
